import React from "react";
import "./Vikas.css";

const plans = [
  {
    id: 1,
    title: "महात्मा गांधी राष्ट्रीय ग्रामीण रोजगार हमी योजना (MGNREGA)",
    description:
      "ग्रामीण भागात किमान १०० दिवसांचे रोजगार उपलब्ध करून देणे हा योजनेचा मुख्य उद्देश आहे.",
    points: [
      "स्थानिक लोकांना रोजगार उपलब्ध",
      "गावात विकास कामांना प्रोत्साहन",
      "वृक्षरोपन, रस्ता, नालीकाम, तलाव खोलीकरण"
    ],
    eligibility: "१८ वर्षे वरील सर्व ग्रामीण कामगार पात्र",
    benefits: "किमान मजुरी दरानुसार वेतन",
    link: "https://nrega.dord.gov.in/MGNREGA_new/Nrega_home.aspx"
  },
  {
    id: 2,
    title: "जनसुविधा / प्रधानमंत्री ग्राम सड़क योजना",
    description:
      "ग्रामीण भागातील रस्ते, शाळा शौचालय इ. सुविधा विकसित करण्यासाठी केंद्र व राज्य सरकारची योजना.",
    points: [
      "सीमेंट रस्ते बांधकाम",
      "प्राथमिक/माध्यमिक शाळेत शौचालय सुविधा",
      "ग्रामीण भागात दळणवळण सुधारणा"
    ],
    eligibility: "ग्रामीण भागातील सर्व नागरिक",
    benefits: "गावात मूलभूत सुविधा उपलब्ध",
    link: "https://pmgsy.nic.in/"
  },
  {
    id: 3,
    title: "अनुजाती व नवबौद्ध घटकांच्या वस्तीचा विकास",
    description:
      "अनुसूचित जाती आणि नवबौद्ध वस्तीमध्ये मूलभूत सुविधा निर्माण करण्याची योजना.",
    points: [
      "नाली बांधकाम",
      "सीमेंट रस्ते",
      "वीज व पिण्याच्या पाण्याची सुविधा"
    ],
    eligibility: "SC / नवबौद्ध समुदाय",
    benefits: "शासकीय अनुदानाद्वारे विकास",
    link: "https://sjsa.maharashtra.gov.in/"
  },
  {
    id: 4,
    title: "स्वच्छ भारत मिशन (ग्रामीण)",
    description:
      "देशातील प्रत्येक गाव स्वच्छ आणि खुल्या जागेत शौचमुक्त करणे हा उद्देश.",
    points: [
      "घराघरात व्यक्तिगत शौचालय बांधकाम",
      "कचरा वेगळा करणे – Segregation",
      "सांडपाणी व्यवस्थापन",
      "ग्रामीण स्वच्छता जनजागृती"
    ],
    eligibility: "भारताचा कोणताही नागरिक",
    benefits: "अनुदान + आरोग्य सुधारणा",
    link: "https://swachhbharatmission.gov.in/sbmcms/index.htm"
  },
  {
    id: 5,
    title: "लाडकी बहिण योजना (महाराष्ट्र)",
    description:
      "मुलींच्या शिक्षणासाठी आणि जन्मदर वाढीसाठी महिलांना आर्थिक मदत देण्याची योजना.",
    points: [
      "जन्म नोंदणी झाल्यावर लाभ",
      "शिक्षणासाठी आर्थिक सहाय्य",
      "आरोग्य सुधारणा योजना"
    ],
    eligibility: "महाराष्ट्रातील मुलींना लागू",
    benefits: "एकरकमी आर्थिक मदत शासनाकडून",
    link: "https://ladakibahin.maharashtra.gov.in/"
  }
];

export default function PlansList() {
  return (
    <div className="plans-container">
      <h1 className="page-title">विकास कार्य / शासन योजना</h1>

      {plans.map((p) => (
        <div className="plan-card" key={p.id}>
          <h2 className="plan-title">{p.title}</h2>

          <p className="plan-desc">{p.description}</p>

          <h4>प्रमुख कामे / वैशिष्ट्ये</h4>
          <ul className="plan-points">
            {p.points.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>

          <p><strong>पात्रता:</strong> {p.eligibility}</p>
          <p><strong>लाभ:</strong> {p.benefits}</p>

          <a href={p.link} target="_blank" rel="noopener noreferrer" className="plan-link">
            अधिक वाचा →
          </a>
        </div>
      ))}
    </div>
  );
}
